import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/utils/http-service.service';

export type ModuloDeclaracao = 'pad' | 'tac';

@Injectable({
  providedIn: 'root'
})
export class VerificarAutenticidadeService {

  constructor(private service: HttpService) {}

  verificarAutenticidade(codigo: string, modulo: ModuloDeclaracao) {
    const path = modulo === 'tac'
      ? 'tac/declaracao/verificar-autenticidade'
      : 'pad/certidao/verificar-autenticidade';
    return this.service.sendPost(path, { codigo });
  }

  downloadPdf(codigo: string, modulo: ModuloDeclaracao) {
    const path = modulo === 'tac'
      ? 'tac/declaracao/verificar-autenticidade-pdf'
      : 'pad/certidao/verificar-autenticidade-pdf';
    return this.service.sendPost(path, { codigo });
  }
}
